import { nanoid } from 'nanoid'
import { type ActionItem, toastStore } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'
import { type RowUser } from 'entities/Users/model/Table/RowUser'
import { UsersApi } from 'entities/Users/api/users'
import { type IUser } from 'entities/Users'

export const logoutAllDevicesAction = (
  members: RowUser[] | IUser[],
  onSuccess?: () => void | Promise<void>,
  bulk?: {
    all: boolean
    search: string
    total: number
  }
) => {
  const membersCount = bulk?.all ? bulk.total : members.length
  const isSingle = membersCount === 1

  const modalId = nanoid()

  modalStore.addModal({
    id: modalId,
    type: ModalTypeList.WARNING,
    title: 'Log out all devices?',
    desc: `Member${isSingle ? '' : 's'} will be logged out of all active sessions on all devices`,
    primaryAction: {
      text: `Log out member${isSingle ? '' : 's'}`,
      onAction: async () => {
        try {
          await UsersApi.logoutMembers(
            bulk?.all
              ? { all: true, search: bulk.search }
              : {
                  ids: members.map((member) => member.id),
                  all: false,
                }
          )
          toastStore.add({
            type: 'success',
            title: `Member${isSingle ? '' : 's'} logged out of all devices`,
          })

          onSuccess?.()
          modalStore.closeModal(modalId)
        } catch (error) {
          logger.error(error)

          toastStore.add({
            type: 'error',
            title: 'Something went wrong. Please try again',
          })
        }
      },
    },
    secondaryAction: {
      text: 'Cancel',
      onAction: () => {
        modalStore.closeModal(modalId)
      },
    },
  })
}

export const logoutAllDevices = (
  members: RowUser[] | IUser[],
  onSuccess?: () => void | Promise<void>,
  bulk?: {
    all: boolean
    search: string
    total: number
  }
): ActionItem => {
  return {
    text: 'Log out all devices',
    icon: 'logOut',
    onAction: () => {
      logoutAllDevicesAction(members, onSuccess, bulk)
    },
  }
}
